const COUNTRY = ".js-country";
const STATE = ".js-state";
const FORM_ITEM = ".form-item";
const LOADING_CLASS_NAME = "is-loading";
/**
 * Set true to fill fields
 * @param {Boolean} fillCountry fill the country
 * @param {Boolean} fillState fill the state
 * @param {Function} callbackFunction callback function after api call
 */
function APIGetCountryAndStateFullNames( fillCountry, fillState, callbackFunction ) {
    /**
	 * @param {string} hostname current website hostname
	 */
	let hostname = window.location.hostname;
	/**
	 * @param {string} protocol website protocol
	 */
	let protocol = window.location.protocol;
	/**
	 * @param {string} api_url register button href url
	 */
	let api_url = protocol + "//api." + hostname + "/api/geography/get-country-and-state-full-names";
	$.ajax( {
		url: api_url,
		type: "post",
        beforeSend: function () {
            if ( fillCountry ) {
                let $parentFormItem = $( COUNTRY ).parent( FORM_ITEM );
                $parentFormItem.addClass( LOADING_CLASS_NAME );
            }
            if ( fillState ) {
                let $parentFormItem = $( STATE ).parent( FORM_ITEM );
                $parentFormItem.addClass( LOADING_CLASS_NAME );
            }
        },
		error: function ( response ) {
            if ( fillCountry ) {
                let $parentFormItem = $( COUNTRY ).parent( FORM_ITEM );
                $parentFormItem.removeClass( LOADING_CLASS_NAME );
            }
            if ( fillState ) {
                let $parentFormItem = $( STATE ).parent( FORM_ITEM );
                $parentFormItem.removeClass( LOADING_CLASS_NAME );
            }
            if ( 'function' == typeof callbackFunction ) {
                callbackFunction( "error" );
            }
            console.error( response );
		},
		success: function ( response ) {
            if ( 'function' == typeof callbackFunction ) {
                callbackFunction( response.data );
            }
            if ( fillCountry ) {
                let $parentFormItem = $( COUNTRY ).parent( FORM_ITEM );
                $( COUNTRY ).val( response.data.country );
                $( COUNTRY ).trigger('change');
                $parentFormItem.removeClass( LOADING_CLASS_NAME );
            }
            if ( fillState ) {
                let $parentFormItem = $( STATE ).parent( FORM_ITEM );
                if ( "US" == response.data.country ) {
                    $( STATE ).val( response.data.state );
                    $( STATE ).trigger('change');
                    $parentFormItem.removeClass( "is-disabled" );
                }
                $parentFormItem.removeClass( LOADING_CLASS_NAME );
            }
		}
	} );
};

export { APIGetCountryAndStateFullNames };